module.exports = __webpack_public_path__ + "static/media/optima-seguros-parking-selected.a140858a.svg";